import type { TOC } from '@ember/component/template-only';
import t from 'ember-intl/helpers/t';

interface VisitorSignedOutSignature {
  Blocks: {
    default?: [];
  };
}

export default <template>
  <div class="h-full w-full absolute top-0 left-0 md:flex items-center justify-center">
    <div class="h-full md:rounded-lg md:flex md:shadow-md md:h-88">
      <div
        class="h-full bg-white overflow-y-auto p-6 fast-transition relative overflow-hidden md:mt-0 md:w-143 md:rounded-lg"
      >
        <div class="flex flex-col h-full items-center content-center justify-center">
          <h1 class="text-6xl waving">👋</h1>
          <h3 class="text-1.5xl mb-2 mt-6">
            {{t "visitor.thanks_for_visiting"}}
          </h3>

          {{#if (has-block)}}
            {{yield}}
          {{else}}
            <p class="pb-12 text-center absolute bottom-0 md:py-2 md:relative">
              {{t "visitor.you_are_signed_out"}}
            </p>
          {{/if}}
        </div>
      </div>
    </div>
  </div>
</template> satisfies TOC<VisitorSignedOutSignature>;
